import { ChangeEvent, FunctionComponent, useState } from "react";
import { Icon } from "../Icon";

type Props = {
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  validPassword: boolean;
};

const PasswordInput: FunctionComponent<Props> = ({
  handleChange,
  validPassword,
}) => {
  const [hide, setHide] = useState<boolean>(true);
  return (
    <section className="password__container">
      <input
        className={validPassword ? "" : "error__input"}
        name="password"
        type={hide ? "password" : "text"}
        id="password"
        onChange={handleChange}
      />
      <div className="hide__container" onClick={() => setHide(!hide)}>
        <Icon className="hide__icon" iconName={hide ? "unhide" : "hide"} />
      </div>
    </section>
  );
};

export default PasswordInput;
